<template>
  <v-app
    id="app"
    class="white"
    :class="{
      ['font--size--' + fontSize]: true,
      'high--contrast': highContrast
    }"
    :dark="highContrast"
  >
    <router-view :key="$route.path"></router-view>
    <toast :message="toast" :show-toast="toast !== null"></toast>
    <error-toast
      :error="errorToast"
      :show-toast="errorToast !== null"
    ></error-toast>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import ErrorToast from "@/components/ErrorToast";
import Toast from "@/components/Toast";

import defaultTheme from "./plugins/default-theme";
import unimedTheme from "./plugins/unimed-theme";
import { storage } from "@/plugins";

const { mapState } = createNamespacedHelpers("portal");

export default {
  name: "App",
  components: {
    ErrorToast,
    Toast
  },
  computed: mapState(["toast", "errorToast", "fontSize", "highContrast"]),
  async created() {
    var oauth = storage.getItem("oauth");
    if (oauth) {
      var themeDefault = storage.getItem("themeDefault");
      if (eval(themeDefault)) {
        this.$vuetify.theme = unimedTheme;
      } else {
        this.$vuetify.theme = defaultTheme;
      }
    }
  }
};
</script>

<style lang="scss">
html {
  overflow-y: auto;
}
.application--wrap {
  background: #f3f3f3;
}
.v-card {
  border-radius: 5px;
}
.overflow--auto {
  overflow: auto;
}
.purple-table thead {
  background-color: #411564;
}
.purple-table thead th,
.purple-table thead i {
  color: #fff !important;
}
@media only screen and (min-width: 1904px) {
  .container.limited {
    max-width: 1185px;
    margin-left: 0;
  }
}

.high--contrast {
  .body-white {
    color: #fff !important;
  }
  .application--wrap {
    background: #fff;
  }
  .display-2 {
    color: #fff;
  }
  .display-1 {
    color: #fff !important;
  }
  .headline {
    color: #fff !important;
  }
  .subheading {
    color: #fff !important;
  }
  .body-2 {
    color: #fff !important;
  }
  .body-1 {
    color: #fff;
  }
  .purple-table thead {
    background-color: #424242;
  }
  .footer-portal {
    background-color: #424242 !important;
  }
}

$size: 4;
@while $size > 0 {
  .font--size--#{$size} {
    .display-2 {
      font-size: #{45 + $size}px !important;
    }
    .display-1 {
      font-size: #{34 + $size}px !important;
    }
    .headline {
      font-size: #{24 + $size}px !important;
    }
    .title {
      font-size: #{20 + $size}px !important;
    }
    .subheading {
      font-size: #{16 + $size}px !important;
    }
    .body-2 {
      font-size: #{14 + $size}px !important;
    }
    .body-1 {
      font-size: #{14 + $size}px !important;
    }
    .caption {
      font-size: #{12 + $size}px !important;
    }
  }
  $size: $size - 1;
}
</style>
